import { Card, CardBody, Col, Row } from 'reactstrap'
import { CustomProgressBars, GettingStarted } from '../../../../utils/Constant'
import { Fragment } from 'react'
import { H6, Progressbar } from '../../../../AbstractElements'
import { customProgressData, customProgressList } from '../../../../Data/Ui-Kits/Progress/Progress'
import CardHeaderCommon from '../../../../CommonElements/CardHeaderCommon/CardHeaderCommon'

const CustomProgressBarsCart = () => {
  return (
    <Card>
      <CardHeaderCommon title={CustomProgressBars} span={customProgressData} />
      <CardBody>
        <Row className="progress-showcase">
          <Col>
            <H6 className="mb-2">{GettingStarted}</H6>
            <Progressbar value="0" striped animated className="text-center"></Progressbar>
            {customProgressList.map(({ color, value, title, text }, index) => (
              <Fragment key={index}>
                <H6 className="mb-2">{title}</H6>
                <Progressbar color={color} striped animated value={value} className=" mb-4">
                  {text}
                </Progressbar>
              </Fragment>
            ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default CustomProgressBarsCart